import { render, staticRenderFns } from "./FilmTabReport.vue?vue&type=template&id=4fce4639&scoped=true&"
import script from "./FilmTabReport.vue?vue&type=script&lang=js&"
export * from "./FilmTabReport.vue?vue&type=script&lang=js&"
import style0 from "./FilmTabReport.vue?vue&type=style&index=0&id=4fce4639&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fce4639",
  null
  
)

component.options.__file = "FilmTabReport.vue"
export default component.exports